import client from './client';

export async function list(params = {}) {
  const { data } = await client.get('/api/actions', { params });
  return data;
}

export async function get(id) {
  const { data } = await client.get(`/api/actions/${id}`);
  return data;
}

export async function create(body) {
  const { data } = await client.post('/api/actions', body);
  return data;
}

export async function assign(id, assignedUserId) {
  const { data } = await client.patch(`/api/actions/${id}/assign`, { assignedUserId });
  return data;
}

export async function setStatus(id, status, completionNote, completionPhotoDataUrl) {
  const { data } = await client.patch(`/api/actions/${id}/status`, {
    status,
    completionNote,
    completionPhotoDataUrl,
  });
  return data;
}

export async function addNote(id, note) {
  const { data } = await client.post(`/api/actions/${id}/notes`, { note });
  return data;
}
